module.exports = __webpack_public_path__ + "img/bg.83eb2cd8.jpg";